// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { brandDetailsCategoriesStyle } from "@hardwoods/App/WidgetExtensions/BrandsDetails/BrandsSharedStyle";
import { categoryListStyles } from "@insite/content-library/Widgets/Category/CategoryList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridWidths } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

categoryListStyles.innerContainer = {
    ...brandDetailsCategoriesStyle.innerContainer,
};

const width = [12, 12, 6, 3.4, 3] as any;
categoryListStyles.categoryItem = {
    ...brandDetailsCategoriesStyle.itemContainer,
    css: css`
        &&&& {
            ${({ theme }: { theme: BaseTheme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: ${(width[0] / 12) * 100}%;
                            flex-basis: ${(width[0] / 12) * 100}%;
                            justify-content: center;
                        `,
                        css`
                            max-width: ${(width[1] / 12) * 100}%;
                            flex-basis: ${(width[1] / 12) * 100}%;
                            justify-content: center;
                        `,
                        css`
                            max-width: ${(width?.[2] / 12) * 100}%;
                            flex-basis: ${(width[2] / 12) * 100}%;
                            justify-content: center;
                        `,
                        css`
                            max-width: ${(width[3] / 12) * 100}%;
                            flex-basis: ${(width[3] / 12) * 100}%;
                        `,
                        css`
                            max-width: ${(width[4] / 12) * 100}%;
                            flex-basis: ${(width[4] / 12) * 100}%;
                        `,
                    ],
                    "min",
                );
            }}
        }
    `,
};

categoryListStyles.categoryImageItem = {
    ...brandDetailsCategoriesStyle.imageGridItem,
};

categoryListStyles.categoryImageLink = {
    ...brandDetailsCategoriesStyle.categoryImageLink,
};

categoryListStyles.categoryImage = {
    ...brandDetailsCategoriesStyle.categoryImage,
};

categoryListStyles.categoryNameLinkItem = {
    ...brandDetailsCategoriesStyle.categoryNameLinkGridItem,
};

categoryListStyles.categoryNameLink = {
    ...brandDetailsCategoriesStyle.categoryNameLink,
};

categoryListStyles.categoryName = undefined;

categoryListStyles.subCategoryNameLink = {
    ...brandDetailsCategoriesStyle.subCategoryNameLink,
};

categoryListStyles.viewMoreLinkItem = {
    ...brandDetailsCategoriesStyle.viewMoreLinkItem,
};

categoryListStyles.viewMoreLink = {
    ...brandDetailsCategoriesStyle.viewMoreLink,
};
